/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Insert_ButtonInputs */



/**
* | output |
* | --- |
* | "Insert Speaker" |
*
* @param {Insert_Speaker_Insert_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_insert_button = /** @type {((inputs?: Insert_Speaker_Insert_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Insert_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer le locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecher einbauen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить динамик")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar altavoz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入扬声器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alto-falante de inserção")
	return /** @type {LocalizedString} */ ("Insert Speaker")
});